import React from 'react'

const ViewListMapButton = (props) => (
  <>
    <button
      type="button"
      className={`toggle ${props.mapActive ? 'toggle-active' : 'toggle-inactive'}`}
      onClick={() => {props.handleToggleClick('map') }}
    >
      <span className="nsw-material-icons material-icons" aria-hidden="true">map</span>
      <strong>Map View</strong>
    </button>
    <button type="button"
      className={`toggle ${!props.mapActive ? 'toggle-active' : 'toggle-inactive'}`}
      onClick={() => {props.handleToggleClick('list') }}
    >
      <span className="material-icons nsw-material-icons" aria-hidden="true">list</span>
      <strong>List View</strong>
    </button>
  </>
)

export default ViewListMapButton
